import Layout from "../components/Layout/Layout"
import HeroSection from "../components/HeroSection/HeroSection";
import AuctionContent from "../components/AuctionContent/AuctionContent";
import { useSelector } from 'react-redux';

const Auction = () => {
    const isMobileFilterOpen = useSelector((state) => state.filter.isMobileFilterOpen);
    
    return (
        <>
            <Layout>
                <HeroSection hideSearchBar={isMobileFilterOpen}/>
                <AuctionContent/>
            </Layout>
        </>
    )
}

export default Auction;